import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-wizard-navigation',
    imports: [CommonModule],
    templateUrl: './wizard-navigation.component.html',
    styleUrl: './wizard-navigation.component.scss'
})
export class WizardNavigationComponent {
  @Input() showBack = true;
  @Input() showNext = true;
  @Input() showFinish = false;
  @Input() showPreview = false;
  @Input() showCancel = true;
  @Input() disableNext = false;
  @Input() showNextOnly = false;
  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() finish = new EventEmitter<void>();
  @Output() preview = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  impersonatedUser:any = localStorage.getItem("impersonatedUser") ?? ""

  onBack() {
    this.back.emit();
  }

  onNext() {
    this.next.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  onFinish() {
    this.finish.emit();
  }
  onPreview() {
    this.preview.emit();
  }
}
